export const replaceStrToDots = (str: string, limit: number) => {
  if (str.length > limit) {
    str = str.slice(0, limit) + '...'
  }
  return str
}
